import React from 'react';
import { T } from '../../../../../../common/locale/translate';
import DesktopInfoboxes from './desktop-infoboxes';
import MobileInfoboxes from './mobile-infoboxes';

export default class CategoriesSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndexDesktop: 0,
      selectedIndexMobile: null
    };
  }

  render() {
    const { params: infoboxes } = this.props;
    const { selectedIndexDesktop, selectedIndexMobile } = this.state;

    return (
      <section className="categories">
        <h3>{T('get_inspired')}</h3>
        <p>{T('choose_category')}</p>
        <span className="hyphen">{/* ornament */}</span>

        <article className="wrapper">
          <MobileInfoboxes
            infoboxes={infoboxes}
            selectedIndexMobile={selectedIndexMobile}
            onClick={this.handleSelection}
          />
          <DesktopInfoboxes
            infoboxes={infoboxes}
            selectedIndexDesktop={selectedIndexDesktop}
            onClick={this.handleSelection}
          />
        </article>
      </section>
    );
  }

  handleSelection = index => {
    this.setState(prevState => ({
      selectedIndexDesktop: index,
      selectedIndexMobile:
        prevState.selectedIndexMobile === index ? null : index
    }));
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/categories_section/categories.jsx